/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ id: NonNullable<unknown> }} Notifications_Subscriptionid1Inputs */

const id_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Langganan ${i?.id}`)
};

const ms_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Langganan ${i?.id}`)
};

const da_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abonnement ${i?.id}`)
};

const de_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abonnement ${i?.id}`)
};

const en_us2_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Subscription ${i?.id}`)
};

const es_es2_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Suscripción ${i?.id}`)
};

const es_mx2_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Suscripción ${i?.id}`)
};

const fil_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Subscription ${i?.id}`)
};

const fr_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abonnement ${i?.id}`)
};

const it_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sottoscrizione ${i?.id}`)
};

const hu_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Feliratkozás ${i?.id}`)
};

const nl_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abonnement ${i?.id}`)
};

const no_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abonnement ${i?.id}`)
};

const pl_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Subskrypcja ${i?.id}`)
};

const pt_br2_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Assinatura ${i?.id}`)
};

const pt_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Subscrição ${i?.id}`)
};

const ro_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abonament ${i?.id}`)
};

const fi_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tilaus ${i?.id}`)
};

const sv_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prenumeration ${i?.id}`)
};

const vi_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đăng ký ${i?.id}`)
};

const tr_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abonelik ${i?.id}`)
};

const cs_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Odběr ${i?.id}`)
};

const bg_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Абонамент ${i?.id}`)
};

const ru_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Подписка ${i?.id}`)
};

const uk_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Підписка ${i?.id}`)
};

const ar_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`الاشتراك ${i?.id}`)
};

const hi_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`सब्सक्रिप्शन ${i?.id}`)
};

const th_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`การสมัครรับ ${i?.id}`)
};

const ja_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`サブスクリプション ${i?.id}`)
};

const zh_cn2_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`订阅 ${i?.id}`)
};

const zh_hant1_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`訂閱 ${i?.id}`)
};

const ko_notifications_subscriptionid1 = /** @type {(inputs: Notifications_Subscriptionid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`구독 ${i?.id}`)
};

/**
* | output |
* | --- |
* | "Subscription {id}" |
*
* @param {Notifications_Subscriptionid1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_subscriptionid1 = /** @type {((inputs: Notifications_Subscriptionid1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Subscriptionid1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_subscriptionid1(inputs)
	if (locale === "ms") return ms_notifications_subscriptionid1(inputs)
	if (locale === "da") return da_notifications_subscriptionid1(inputs)
	if (locale === "de") return de_notifications_subscriptionid1(inputs)
	if (locale === "en-US") return en_us2_notifications_subscriptionid1(inputs)
	if (locale === "es-ES") return es_es2_notifications_subscriptionid1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_subscriptionid1(inputs)
	if (locale === "fil") return fil_notifications_subscriptionid1(inputs)
	if (locale === "fr") return fr_notifications_subscriptionid1(inputs)
	if (locale === "it") return it_notifications_subscriptionid1(inputs)
	if (locale === "hu") return hu_notifications_subscriptionid1(inputs)
	if (locale === "nl") return nl_notifications_subscriptionid1(inputs)
	if (locale === "no") return no_notifications_subscriptionid1(inputs)
	if (locale === "pl") return pl_notifications_subscriptionid1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_subscriptionid1(inputs)
	if (locale === "pt") return pt_notifications_subscriptionid1(inputs)
	if (locale === "ro") return ro_notifications_subscriptionid1(inputs)
	if (locale === "fi") return fi_notifications_subscriptionid1(inputs)
	if (locale === "sv") return sv_notifications_subscriptionid1(inputs)
	if (locale === "vi") return vi_notifications_subscriptionid1(inputs)
	if (locale === "tr") return tr_notifications_subscriptionid1(inputs)
	if (locale === "cs") return cs_notifications_subscriptionid1(inputs)
	if (locale === "bg") return bg_notifications_subscriptionid1(inputs)
	if (locale === "ru") return ru_notifications_subscriptionid1(inputs)
	if (locale === "uk") return uk_notifications_subscriptionid1(inputs)
	if (locale === "ar") return ar_notifications_subscriptionid1(inputs)
	if (locale === "hi") return hi_notifications_subscriptionid1(inputs)
	if (locale === "th") return th_notifications_subscriptionid1(inputs)
	if (locale === "ja") return ja_notifications_subscriptionid1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_subscriptionid1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_subscriptionid1(inputs)
	return ko_notifications_subscriptionid1(inputs)
});
export { notifications_subscriptionid1 as "notifications.subscriptionId" }